// src/components/analysis/detail/CompletenessDetail.js
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

const CompletenessDetail = ({ data }) => {
  return (
    <Box>
      {data.split('\n').map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Chip 
            label={item.includes('Present') ? 'Present' : 'Missing'} 
            color={item.includes('Present') ? 'success' : 'error'} 
            size="small" 
            sx={{ mr: 2 }} 
          />
          <Typography variant="body1">
            {item.split('-')[0].replace('**', '').replace('**', '')}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CompletenessDetail;
